import React from "react"
import style from "../vdp.module.scss"

export default function useOptionalIncentives(incentivesList = [], Pricing) {

    const today = new Date();
    incentivesList = incentivesList.filter(offer => {
        // Check if EndDate is less than or equal to today
        const offerEndDate = new Date(offer.EndDate);
        const isEndDateValid = offerEndDate > today;

        // Check if offer name doesn't include 'Enterprise'
        const isNotEnterprise = !offer.Name.includes("Enterprise");

        //Check if offer has a price
        const hasPrice = offer.Price !== "" && offer.Price !== "$0"

        // Return true only if all conditions are met
        return isEndDateValid && isNotEnterprise && hasPrice;
    });

  const optionalIncentiveSum = (Pricing.List > 0) && Array.isArray(incentivesList) ? 
    incentivesList.map(incentive => {
      return parseFloat(incentive.Price.replace("$",""))
    }).reduce((prev, curr) => {
      return prev + curr
    }, 0) : 0

  
  const renderOptionalIncentives = () => (
    (optionalIncentiveSum > 0) &&
    <div style={{ marginBottom: "1em" }}>
      {/* <hr style={{ width: "100%" }} /> */}
      <p className={style["offer-name"]}>Additional Savings - Conditional Offers</p>
      {incentivesList.map(incentive => (
        <div className={style["vdp-incentives"]}>
          <div style={{ position: "relative", paddingRight: "24px", paddingTop: "10px" }}>
            <p>{incentive.Name}</p>
              <>
                <span className={style["incentive-info"]}>
                </span>
                <div className={style["incentive-detail"]}>
                  <p>{incentive.Description ? (incentive.Description !="No description" ? incentive.Description : ''): ''}</p>
                  {incentive.EndDate === "" ? <span>See dealer for more details and offer end date.</span> :  <span>Offer valid through: {incentive.EndDate}. See dealer for more details.</span> }
                </div>
              </>
          </div>
          <span>{`${incentive.Price}`}</span>
        </div>
      ))
      }
      <hr style={{ width: "100%" }} />
    </div>
  )

  return [renderOptionalIncentives, Number(optionalIncentiveSum)]
}